import { render } from "./SelectIngredientModal2.vue?vue&type=template&id=70dafec9"
import script from "./SelectIngredientModal2.vue?vue&type=script&lang=js"
export * from "./SelectIngredientModal2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__